import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "MasterRule/";

export default class {

  static getMasterRule(masterRuleId) {

    let url = `${config.uploadUrl + route}Get`;

    return http({
      url,
      method: "GET",
      params: { masterRuleId },
    });
  }

  static getChildRulesForMasterRule(masterRuleId) {

    let url = `${config.uploadUrl + route}GetChildRulesForMasterRule`;

    return http({
      url,
      method: "GET",
      params: { masterRuleId },
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/masterRule.js